import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  get pageNavNext() {
    return this.element.querySelector('#page-nav .next a');
  }

  connect() {
    document.querySelectorAll(".week6 .choices button").forEach((button) => {
      button.addEventListener("click", () => {
        if (isAnswerCorrect(button)) {
          showCorrectFeedback();
          this.enableNextNavigation();
        } else {
          showIncorrectFeedback(button.dataset.feedback);
        }
      });
    });

    document
      .querySelectorAll(".week6 .exercise.choices img")
      .forEach((image) => {
        image.addEventListener("click", () => {
          hideAllFeedback();
          this.showFeedback(image);
        });
      });

    function isAnswerCorrect(element) {
      return element.dataset.isCorrect == "true";
    }

    function showCorrectFeedback() {
      incorrectFeedback().style.display = "none";
      correctAnswer().style.display = "block";
      correctFeedback().style.display = "block";
    }

    function showIncorrectFeedback(feedback) {
      correctFeedback().style.display = "none";
      correctAnswer().style.display = "none";
      incorrectFeedback().innerHTML = feedback;
      incorrectFeedback().style.display = "block";
    }

    function correctFeedback() {
      return document.querySelector(".feedback.correct");
    }

    function incorrectFeedback() {
      return document.querySelector(".feedback.incorrect");
    }

    function correctAnswer() {
      return (
        document.querySelector(".correct-answer") || document.createElement("span")
      );
    }

    function hideAllFeedback() {
      document.querySelectorAll(".game.feedback").forEach(function (feedback) {
        feedback.style.display = "none";
      });
    }
  }

  showFeedback(image) {
    const wrapper = document.getElementById(image.dataset.name + "-feedback")
    wrapper.style.display = "block";
    const feedback = wrapper.querySelector('.feedback');
    feedback.style.display = 'block';
    if (feedback.classList.contains('correct')) {
      this.enableNextNavigation();
    }
  }

  enableNextNavigation() {
    this.pageNavNext.removeAttribute('disabled');
  }
}
